if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    const target = document.querySelector(".cart-drawer__dialog");

    const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === "attributes" && mutation.attributeName === "open") {
        if (target.hasAttribute("open")) {
            BSS_B2B.dc.initFunction()
        }
        }
    });
    });

    observer.observe(target, {
    attributes: true,
    attributeFilter: ["open"]
    });
}